import React from 'react';
import { useNavigate } from 'react-router-dom'; // <-- important import
import './Psyco.css';

const Psyco = () => {
  const navigate = useNavigate(); // <-- initialize navigate

  return (
    <div className="psyco">
      <div className="content-section5">
        <div className='abc'>
          <div className="image-column5">
            <div className="consulting-image5">
            </div>
          </div>
          <div className='abc1'>
          </div>
        </div>
        <div className='def'>
          <div className='def'></div>       
          <div className="text-column5">
            <h1 className="headline5">Psychometric Assessment</h1>
            <h2 className="subheadline5">Feel Better Today and Everyday.</h2>
            <p className="description5">
              At PsyCare, our expert psychologists provide personalized consulting to help you navigate life’s challenges. Whether you’re seeking clarity, emotional support, or strategies for well-being, we’re here for you.
            </p>
            <button
              className="read-more-btn5"
              onClick={() => navigate('/StartScreeningTest')} // <-- Correct navigation
            >
              Take Pyschometric Test
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Psyco;